export default __webpack_public_path__ + "aa09d78a1488c70ed66613044e9dc77d.svg";